import { render, staticRenderFns } from "./PersonSelectStep.vue?vue&type=template&id=59865f24&scoped=true"
import script from "./PersonSelectStep.vue?vue&type=script&lang=js"
export * from "./PersonSelectStep.vue?vue&type=script&lang=js"
import style0 from "./PersonSelectStep.vue?vue&type=style&index=0&id=59865f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59865f24",
  null
  
)

export default component.exports